<template>
    <Modal :alwaysShow="true" :header="headerText" @hide="$emit('hide')">
        <FormGroup :form="form" title="Name" field="name">
            <input class="form-control" v-model="form.data.name" :disabled="saving" @keyup.enter="save" v-focus />
        </FormGroup>

        <FormGroup :form="form" title="Notes" field="notes">
            <textarea class="form-control" v-model="form.data.notes" :disabled="saving" v-autosize></textarea>
        </FormGroup>

        <div class="checkbox">
            <label>
                <input type="checkbox" v-model="form.data.is_public" />
                Public
            </label>
            <p class="help-block">Public watch lists can be viewed and updated by other users.</p>
        </div>

        <template slot="footer">
            <button class="btn btn-primary" @click="save" :disabled="saving">Save Watch List</button>
        </template>
    </Modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Form from '@/helpers/Form';

export default {
    props: ['watchList'],
    data() {
        return {
            saving: false,
            form: new Form({
                id: '',
                is_public: false,
                name: '',
                notes: null,
            }),
        };
    },
    computed: {
        headerText() {
            return (this.watchList) ? 'New Watch List' : 'Edit Watch List';
        },
    },
    created() {
        this.updateForm();
    },
    methods: {
        ...mapActions('data', ['createWatchList', 'updateWatchList']),
        updateForm() {
            if (this.watchList)
                this.form.updateData(this.watchList);
            else
                this.form.clearData();
        },
        async save() {
            this.saving = true;

            try {
                let saveMethod = (this.watchList) ? 'updateWatchList' : 'createWatchList';
                let watchList = await this.form.save(() => this[saveMethod]({ watchList: this.form.data }));

                this.$emit('saved', watchList);
                this.$emit('hide');
            }
            catch (e) {
                if (!e.isValidationError)
                    swal('Couldn\'t save watch list', 'Please try again later', 'error');
            }

            this.saving = false;
        },
    },
}
</script>
